import { getProp } from '@mx/util/get-prop';
import { LS } from '@mx/util/local-storage';
import { toast } from '@mx/vix';
import { bridge, ajax } from './index';

export function updateBankCardList(that: any, type: string) {
  bridge
    .getStorage('pay-bindcard-success')
    .then((result) => {
      const value = result.value;
      if (value) {
        toast.show('success', '绑卡成功');
        that.hasAvailableCard = true;
        bridge
          .getStorage('pay-bindcard-success-bankcardid')
          .then((data) => {
            const val = data.value;
            updateBankList(val, type, that);
          })
          .catch(() => {});
      }
    })
    .catch(() => {});
}
function updateBankList(payBindedBankcardID: string, type: string, that: any) {
  let url;
  if (type === 'withdraw') {
    url = '/balance/withdrawBankcardList';
  } else {
    url = '/balance/rechargeBankcardList';
  }
  ajax({ data: {}, url })
    .then((res: any) => {
      if (res.status === 'success') {
        const data = res.data;
        data.payBindedBankcardID = payBindedBankcardID;
        if (data.banklist_page && data.banklist_page.banklist) {
          that.bankCardList = data.banklist_page.banklist;
          const banklist = data.banklist_page.banklist;
          // tslint:disable-next-line:prefer-for-of
          for (let i = 0; i < banklist.length; i++) {
            if (
              // tslint:disable-next-line:max-line-length
              banklist[i].pay_type === 'quickbank' &&
              getProp(banklist[i], ['card_info', 'bank_card'], false) === data.payBindedBankcardID
            ) {
              that.selectedCardIndex = i;
              that.selectedCard = banklist[i];
              that.hasAvailableCard = that.selectedCardIndex !== -1;
              if (type === 'recharge') {
                that.changeTip(that.amount);
              } else {
                const amount = LS.get('amount');
                if (amount) {
                  if (that.startData.amount !== amount) {
                    that.tipInfo();
                  }
                } else {
                  that.tipInfo();
                }
              }
              break;
            }
          }
        }
      }
    })
    .catch((err) => {});
}
